import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SplashWelcomeScreenStepElementContentModel,
  SplashWelcomeScreenStepPropertiesModel,
} from '@/services/platform/api/model';
import ModuleWrapper from '../../../../shared/module/wrapper';
import { cn, getFirstName, ModuleProperties, SplashContext, useAuthStore } from '@/lib/core';
import { getTimeOfDayWord } from '@/lib/core/utils/text';
import { consumeDeepLinkTarget } from '@/lib/core/hooks/deepLinkTarget';

export const SplashWelcomeScreenStep = (props: ModuleProperties) => {
  const { user, setIsWelcomed } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    const id = setTimeout(() => {
      navigate(consumeDeepLinkTarget() ?? '/');
      setIsWelcomed(true);
      (props.context as SplashContext)?.onComplete?.();
    }, 2000);
    return () => clearTimeout(id);
  }, [navigate, setIsWelcomed]);

  const content = props.content as SplashWelcomeScreenStepElementContentModel | undefined;

  if (!content) return null;

  const properties = content.properties as SplashWelcomeScreenStepPropertiesModel;
  const userName = getFirstName(user?.name || undefined);

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['step__welcome', 'justify-start!', 'min-h-[calc(100vh-48px)]']),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex', 'flex-col', 'flex-1', 'justify-center', 'gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      <div className="flex flex-col items-center gap-2 px-4 text-center">
        {properties?.welcomeText && (
          <p className="font-didot-lt-pro flex flex-row items-baseline leading-[120%] text-white">
            <span className="text-[50px] leading-[120%] tracking-[-2.5px] text-nowrap italic">
              {properties.welcomeText} {getTimeOfDayWord()}
            </span>
            <span className="text-[60px] tracking-[-3.5px] italic">,</span>
          </p>
        )}
        {userName && (
          <p className="font-pp-neue-montreal text-[54px] leading-8.5 font-semibold text-white uppercase">
            {userName}
          </p>
        )}
      </div>
    </ModuleWrapper>
  );
};
